import React, { useEffect } from 'react';

export default function GoogleAdSense({ adSlot, adFormat = 'auto', fullWidth = true }) {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.log('AdSense error:', e);
    }
  }, []);

  return (
    <div className="my-4">
      <ins
        className="adsbygoogle"
        style={{
          display: fullWidth ? 'block' : 'inline-block',
          width: '100%',
          height: 'auto',
        }}
        data-ad-client="ca-pub-xxxxxxxxxxxxxxxx"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
}

// Banner Ad Component
export function BannerAd({ adSlot = '1234567890' }) {
  return <GoogleAdSense adSlot={adSlot} adFormat="horizontal" fullWidth={true} />;
}

// Square Ad Component
export function SquareAd({ adSlot = '1234567890' }) {
  return <GoogleAdSense adSlot={adSlot} adFormat="square" fullWidth={false} />;
}

// Responsive Ad Component
export function ResponsiveAd({ adSlot = '1234567890' }) {
  return <GoogleAdSense adSlot={adSlot} adFormat="auto" fullWidth={true} />;
}
